import React from 'react';
import { tinaField } from 'tinacms/dist/react';
import Link from 'next/link';
import Image from 'next/image';
import type { Block } from '@/cms/types';
import type { PageBlocksFundsLogos } from '@/tina/__generated__/types';

export function FundLogos(
  data: Block & {
    title: string;
    logos?: PageBlocksFundsLogos[];
  },
): React.JSX.Element {
  const { title, logos } = data;

  return (
    <div className='container max-w-[812px] py-16 px-4 md:px-0'>
      <div className='text-center'>
        <h2 className='mb-10 md:mb-16 text-4xl font-extrabold'>{title}</h2>
      </div>

      <div className='grid grid-cols-3 gap-8 text-gray-400 md:grid-cols-6'>
        {logos
          ? logos.map((item, i) => {
              return (
                <Partner
                  data-tina-field={tinaField(item)}
                  key={i.toString() + item.__typename}
                  logo={item.image}
                  name={item.name}
                  url={item.url}
                />
              );
            })
          : null}
      </div>
    </div>
  );
}

function Partner({
  name,
  url,
  logo,
  ...props
}: {
  name: string;
  url: string;
  logo: string;
}): React.JSX.Element {
  return (
    <Link
      {...props}
      className='flex justify-center items-center'
      href={url}
      target='_blank'
      title={name}>
      <Image
        alt={name}
        className='rounded-full'
        height={320}
        src={logo}
        width={320}
      />
    </Link>
  );
}
